import React, { Component } from 'react'

import {
  ProfilesContainer,
  CorporateGovernanceButtonText,
  FinancialResultsButtonText
} from './styledComponents'

interface Props {
  onInternTabSwitch: Function
  tabCorporateGovernanceActive: boolean
}

class ProfilesSection extends Component<Props> {
  handleCareersProfileClick = () => {
    const { onInternTabSwitch } = this.props
    onInternTabSwitch(false)
  }

  handleInternsProfileClick = () => {
    const { onInternTabSwitch } = this.props
    onInternTabSwitch(true)
  }

  render() {
    const { tabCorporateGovernanceActive } = this.props
    return (
      <ProfilesContainer>
        <FinancialResultsButtonText
          onClick={this.handleCareersProfileClick}
          tabCorporateGovernanceActive={tabCorporateGovernanceActive}
        >
          Financial Results
        </FinancialResultsButtonText>
        <CorporateGovernanceButtonText
          onClick={this.handleInternsProfileClick}
          tabCorporateGovernanceActive={tabCorporateGovernanceActive}
        >
          Corporate Governance
        </CorporateGovernanceButtonText>
      </ProfilesContainer>
    )
  }
}

export default ProfilesSection
